import { WebhookStatus } from "../api/types";

export function isValidWebhookStatus(value: number): value is WebhookStatus {
  return (
    value === WebhookStatus.Ok ||
    value === WebhookStatus.Error ||
    value === WebhookStatus.NoRegistration ||
    value === WebhookStatus.Mismatch ||
    value === WebhookStatus.NoActualRegistration
  );
}

export function parseWebhookStatus(value: string): WebhookStatus | null {
  const numValue = Number(value);
  if (Number.isNaN(numValue) || !isValidWebhookStatus(numValue)) {
    return null;
  }
  return numValue;
}
